import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
		ref,
		onMounted,
		onUnmounted,
	} from "vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'CloudflareTurnstile',
  setup(__props, { expose: __expose }) {


	const container = ref<HTMLElement | null>(null)

	let widgetId = ""
	let resolveToken: ((token: string) => void) | null = null
	let rejectToken: ((err: Error) => void) | null = null

	onMounted(() => {
		if (process.env.VUE_APP_ENABLE_CF_TURNSTILE !== "1" || !container.value) return

		widgetId = turnstile.render(container.value, {
			sitekey: process.env.VUE_APP_CF_TURNSTILE_SITE_KEY,
			appearance: "interaction-only",
			execution: "execute",
			size: "flexible",
			callback: (token: string) => {
				resolveToken?.(token)
				resolveToken = null
				rejectToken = null
			},
			"expired-callback": () => {
				rejectToken?.(new Error("Security check expired. Please try again."))
				resolveToken = null
				rejectToken = null
			},
			"error-callback": () => {
				rejectToken?.(new Error("Security check failed. Disable any VPNs or ad-blockers and try again."))
				resolveToken = null
				rejectToken = null
			},
		})
	})

	onUnmounted(() => {
		if (widgetId) turnstile.remove(widgetId)
	})

	async function execute(): Promise<string> {
		if (process.env.VUE_APP_ENABLE_CF_TURNSTILE !== "1") return ""

		const token = await new Promise<string>((resolve, reject) => {
			resolveToken = resolve
			rejectToken = reject
			turnstile.execute(widgetId)
		})

		turnstile.reset(widgetId)

		return token
	}

	__expose({ execute })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container
  }, null, 512))
}
}

})